// OnboardingContext — holds the onboarding flow state.

import { createContext, useContext, useState } from 'react';
import { supabase } from '../supabase/supabaseClient';
import { useAuth } from './auth.context';

const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const { user } = useAuth();

  const [onboarding, setOnboarding] = useState({ });
  const [started, setStarted] = useState(null);
  const [completed, setCompleted] = useState(false);

  // Called when onboarding is started. If the user already has an Onboarding row,
  // load it into state; otherwise initialise a fresh onboarding state (local only — not yet persisted).
  const startOnboarding = async () => {
    if (!user) return;

    const { data } = await supabase
      .from('Onboarding')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();

    if (data) {
      setStarted(new Date());
      setCompleted(true);
    }

    setOnboarding(data ?? {});
  };

  const value = { onboarding, setOnboarding, started, completed, startOnboarding };

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
};
